export function getYearFromName(lineArray) {
    const name = lineArray[1]
    const year = String(name).match(/(\d{4})/);
    // if year is not null set the original name to be name without year
    if (year) {
        lineArray[1] = name.replace(year[0], '').replace(/-/g, '').replace("(", '').replace(")", '').replace("/", '');
    }
}

export function cleanDollarField(field) {
    const value = String(field).replace(/\$/g, '').trim()
    return Number(value) || 0
}

export function cleanMultipleLinesField(field) {
    const value = String(field).replace(/\n/g, ',').replace(/\r/g, ',').replace(/,,/g, ',').trim()
    return value || ''
}

export default { getYearFromName, cleanDollarField, cleanMultipleLinesField }